module.exports = __webpack_public_path__ + "img/戴尔.8f90b1ee.png";